"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
let refreshTokenAction;
const callWithRetry = ({ url, utils, payload, meta, cancelToken, onUnauthorized, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { method, includeToken, } = meta;
    const { auth, dispatch } = utils;
    const sendRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d, _e;
        const headers = {};
        if ((_c = utils.options) === null || _c === void 0 ? void 0 : _c.platform) {
            headers['x-platform'] = utils.options.platform;
        }
        if ((_d = utils.options) === null || _d === void 0 ? void 0 : _d.appVersion) {
            headers['x-app-version'] = utils.options.appVersion;
        }
        if ((_e = utils.options) === null || _e === void 0 ? void 0 : _e.deviceName) {
            headers['x-device-name'] = utils.options.deviceName;
        }
        if (auth.isLoggedIn && includeToken !== false) {
            headers.Authorization = `Bearer ${auth.accessToken}`;
        }
        const { data } = yield axios_1.default({
            method,
            url,
            data: payload,
            headers,
            cancelToken: cancelToken.token,
        });
        return data;
    });
    let response;
    try {
        response = yield sendRequest();
    }
    catch (err) {
        if (auth.hasRefreshToken &&
            ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 401 &&
            includeToken !== false) {
            if (!refreshTokenAction) {
                refreshTokenAction = auth.refresh();
                if (onUnauthorized) {
                    refreshTokenAction.catch((refreshErr) => {
                        if (refreshErr.type === 'unauthorized') {
                            onUnauthorized(refreshErr, dispatch);
                        }
                    });
                }
                refreshTokenAction.finally(() => {
                    refreshTokenAction = undefined;
                });
            }
            yield refreshTokenAction;
            response = yield sendRequest();
        }
        else {
            if (onUnauthorized &&
                ((_b = err.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                onUnauthorized(err, dispatch);
            }
            throw err;
        }
    }
    return response;
});
exports.default = callWithRetry;
